//Custom components
import { NumericFormat as NumberFormat } from 'react-number-format';
import StatCard from '../../../UI/Card/StatCard';

const AlabamaBasedDevelopersWidget = ({ count }: { count: number }) => {
  return <StatCard title='Alabama Based Developers' stat={<NumberFormat value={count} displayType='text' thousandSeparator={true} />} />;
};

export default AlabamaBasedDevelopersWidget;
